import React, { useEffect, useState } from "react";
import EnhancedTable from "../elementos/basicos/TablaSubcategoriasConvocatoria";
import { fetchSubcategoriaConvocatoriaFilters, fetchActualizarSubcategorias } from '../../peticiones_API/PeticionesSubcategoriasConvocatoria';
import { useLocation, useNavigate } from 'react-router-dom';


import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';
import Titulo from "./../elementos/basicos/Titulo";
import styled from 'styled-components';

const GestorSubcategoriaConvocatoria = (props) => {

    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));

    let busqueda = params.get("busqueda") || null;
    let numCategorias = params.get("numCategorias");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(true);
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();
    const [data, setData] = useState({
        meta: {},
        rows: []
    });

    const [selected, setSelected] = useState([]);
    const [eliminarTodoSubcategorias, setEliminarTodoSubcategorias] = useState({ atributo: 'visible', valor: null });
    const [eliminarSubSelect, setEliminarSubSelect] = useState({ atributo: 'visible', valor: null });

    const confirmDialog = ConfirmacionEliminar();

    useEffect(() => {
        async function fechtActualizarFiltros() {
            console.log("Entra en el filtro");

            try {
                if (

                    eliminarTodoSubcategorias.valor == false ||
                    eliminarSubSelect.valor == false
                ) {
                    let mensaje = "";

                    if (eliminarTodoSubcategorias.valor === false || eliminarSubSelect.valor === false) {
                        mensaje = "eliminar";
                    }

                    const confirm = await confirmDialog.showAlert(mensaje,"subcategorias");

                    if (confirm) {
                        let subcategoriasActualizar = [];


                        if (eliminarTodoSubcategorias.valor === false) {
                            setEliminarTodoSubcategorias((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const subcategoriasResponse = await fetchSubcategoriaConvocatoriaFilters(
                                paginaActual,
                                registrosPorPag,
                                busqueda,
                                numCategorias,
                                ordenarColumna,
                                orden
                            );

                            subcategoriasResponse.data.forEach((subcategoria) => {
                                subcategoriasActualizar.push(subcategoria.Id);
                            });

                            console.log("Entra en condición de desactivar todos");
                            await fetchActualizarSubcategorias(subcategoriasActualizar, eliminarTodoSubcategorias);
                        }


                        if (eliminarSubSelect.valor == false && selected.length !== 0) {
                            setEliminarSubSelect((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            subcategoriasActualizar = selected;
                            console.log("eliminarSubSelect", eliminarSubSelect);
                            await fetchActualizarSubcategorias(subcategoriasActualizar, eliminarSubSelect);
                        }


                        const subcategoriasResponse = await fetchSubcategoriaConvocatoriaFilters(
                            paginaActual,
                            registrosPorPag,
                            busqueda,
                            numCategorias,
                            ordenarColumna,
                            orden
                        );

                        const { data: categoriasData, meta } = subcategoriasResponse;

                        setData({
                            meta,
                            rows: formatData(categoriasData),
                        });

                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    } else {
                        // Restaurar el estado en caso de cancelación


                        setEliminarTodoSubcategorias((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setEliminarSubSelect((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error al actualizar filtros:", error);
            }
        }



        if (
            eliminarTodoSubcategorias.valor !== null ||
            eliminarSubSelect.valor !== null
        ) {
            fechtActualizarFiltros();
        }
    }, [eliminarTodoSubcategorias, eliminarSubSelect, paginaActual, registrosPorPag, busqueda, numCategorias, ordenarColumna, orden, selected]);


    useEffect(() => {
        async function fechtPrincipal() {
            try {


                if (!paginaActual || !registrosPorPag) {
                    const subcategoriasResponse = await fetchSubcategoriaConvocatoriaFilters(paginaActual, registrosPorPag);
                    const { data: subcategoriasData, meta } = subcategoriasResponse;
                    // console.log("subcategoriasResponse ",subcategoriasResponse);
                    paginaActual = meta.current_page;
                    registrosPorPag = meta.per_page;

                    navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    setData({
                        meta,
                        rows: formatData(subcategoriasData)
                    });
                } else {
                    let urlParams = `?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`;

                    if (busqueda !== null && busqueda !== '' && busqueda !== undefined) {
                        urlParams += `&busqueda=${busqueda}`;
                    }
                    if (numCategorias !== null) {
                        urlParams += `&numCategorias=${numCategorias}`;
                    }

                    if (ordenarColumna !== null) {
                        urlParams += `&ordenarColumna=${ordenarColumna}`;
                    }
                    if (orden !== null) {
                        urlParams += `&orden=${orden}`;
                    }
                    navigate(`${urlPadre}${urlParams}`);
                    const subcategoriasResponse = await fetchSubcategoriaConvocatoriaFilters(paginaActual, registrosPorPag, busqueda, numCategorias, ordenarColumna, orden);
                    console.log("subcategoriasResponse ", subcategoriasResponse);
                    const { data: subcategoriasData, meta } = subcategoriasResponse;
                    setData({
                        meta,
                        rows: formatData(subcategoriasData)
                    });
                }
                setLoading(false);

            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [paginaActual, registrosPorPag, busqueda, numCategorias, ordenarColumna, orden, navigate, urlPadre]);

    const formatData = (data) => {
        return data.map((row) => {

            return {
                id: row.Id,
                nombre: row.nombre.toLowerCase(),
                numCategorias: row.numCategorias,
                editar: row.Id,
            };
        });
    };

    const header = [
        {
            id: 'nombre',
            numeric: false,
            disablePadding: true,
            label: 'Nombre',
        },
        {
            id: 'numCategorias',
            numeric: false,
            disablePadding: true,
            label: 'Categorias',
        },
        {
            id: 'modificar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];


    return (
        <>
            

                <CabeceraForm>
                    <Titulo
                        texto="SUBCATEGORIAS"
                        convocatoria="true"
                        tituloTabla="true"
                    />
                </CabeceraForm>

                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarTodoSubcategorias={eliminarTodoSubcategorias}
                    setEliminarTodoSubcategorias={setEliminarTodoSubcategorias}
                    eliminarSubSelect={eliminarSubSelect}
                    setEliminarSubSelect={setEliminarSubSelect}
                    isLoading={loading}
                />

            
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
`

export default GestorSubcategoriaConvocatoria;
